import { trySafe } from './function.js';

const get = (object, keySerial) => {
    if (object === null || typeof object !== 'object') {
        throw new TypeError('Non-object received in `get()`.');
    }
    let result = object;
    for (const key of keySerial.split('.')) {
        // @ts-expect-error for performance
        result = result[key];
    }
    return result;
};
const getSafe = (...args) => trySafe(() => get(...args));
/** Same to `get()` but with the strict type definition only to enable IntelliSense. */
const getValue = (object, keySerial) => get(object, keySerial);
/* eslint-enable @silverhand/fp/no-let, @silverhand/fp/no-mutation */

export { get, getSafe, getValue };
